import $ from "jquery";
window.$ = $;
window.jQuery = $;
export default $;



// WEBPACK FOOTER //
// ./src/assets/js/vue-superslide/superslide/src/jquery-vendor.js